import { Injectable } from "@angular/core";
import { ChangePasswordModel } from "@obg/ngx.common/types";
import { FeatureFlag, FeatureFlagService } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { AccountSettingsClient } from "./account-settings.client";
import { OptimizelyDefaultFlag } from "./account-settings.model";

export const CROSS_SELL_FEATURE_FLAG_KEY = "cross-sell";

@Injectable({
	providedIn: "root",
})
export class AccountSettingsService {
	private _crossSellFeatureFlag: OptimizelyDefaultFlag | undefined;

	constructor(
		private client: AccountSettingsClient,
		private featureFlagService: FeatureFlagService
	) {}

	changePassword(model: ChangePasswordModel): Observable<object> {
		return this.client.changePassword(model);
	}
	private getCrossSellFeatureFlags(): FeatureFlag<OptimizelyDefaultFlag | undefined> | undefined {
		return this.featureFlagService.get<OptimizelyDefaultFlag | undefined>(CROSS_SELL_FEATURE_FLAG_KEY);
	}

	isEnabledCrossSellFeature(): boolean | undefined {
		if (!this._crossSellFeatureFlag) {
			this._crossSellFeatureFlag = this.getCrossSellFeatureFlags();
		}

		return this._crossSellFeatureFlag?.enabled;
	}
}
